import "../index.scss";
// Comfortaa with weights 400 and 700
import "@fontsource/comfortaa";

// Josefin Sans with weights 100 and 300
import "@fontsource/josefin-sans";

// Montserrat (regular 400 by default)
import "@fontsource/montserrat";
import "./init";
import { ReactNode } from "react";
import ErrorBoundary from "../components/error/ErrorBoundary";
import ErrorManager from "../components/error/ErrorManager";
import InfoManager from "../components/info/InfoManager";
import Footer from "../components/nav/Footer";
import CookieAlert from "../components/info/CookieAlert";
import { TourProvider } from "@reactour/tour";

function Layout({ children }: { children: ReactNode }) {
	return (
		<ErrorBoundary>
			<ErrorManager>
				<InfoManager>
					<TourProvider
						steps={[]}
						afterOpen={() => {
							document.body.style.overflow = "hidden";
						}}
						beforeClose={() => {
							document.body.style.overflow = "";
						}}
						padding={{mask: 20}}
					>
						<div className="app">
							<main className="content">{children}</main>
							<Footer />
							<CookieAlert />
						</div>
					</TourProvider>
				</InfoManager>
			</ErrorManager>
		</ErrorBoundary>
	);
}

export { Layout };
